import { createReducer } from '@ces/sourced-action';
import { on } from '@ngrx/store';
import { LookupState } from 'egov-api';
import { lookupStateLoaded } from './lookup-state.actions';


// Initial state

const initialState = undefined;


// Reducer

export const lookupStateReducer = createReducer<LookupState | undefined>(
    initialState,
    on(lookupStateLoaded, (s, { newState }) => ({ ...newState })),
);
